module.exports = __webpack_public_path__ + "img/scene5-0.f6fc1509.jpg";